import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {UntypedFormArray, UntypedFormGroup} from '@angular/forms';
import {DATA_TYPE} from '@constants/data-type.constant';
import {UtilsService} from '@services/utils/utils.service';

@Component({
    selector: 'scitis-admin-organization-constant-value-item',
    templateUrl: './constant-value-item.component.html',
    styleUrls: ['./constant-value-item.component.scss'],
    standalone: false
})
export class ConstantValueItemComponent implements OnInit {

  @Input()
  parentFormGroup: UntypedFormGroup = new UntypedFormGroup({});

  @Input()
  index: number = -1;

  @Input()
  type: string = '';

  @Input()
  dateTimeFormat: string = 'yyyy-MM-dd';

  @Output()
  removeValueEvent = new EventEmitter<number>();

  @Output()
  dateChangedEvent = new EventEmitter<string>();

  valueItemForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private utilsService: UtilsService
  ) {
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.valueItemForm.controls;
  }

  ngOnInit(): void {
    const array = this.parentFormGroup.controls.editValuesFormArray as UntypedFormArray;
    this.valueItemForm = array.controls[this.index] as UntypedFormGroup;
  }

  onRemoveInterval() {
    this.removeValueEvent.emit(this.index);
  }

  onValueChange() {
    const value: string = this.valueItemForm.controls.value.value;
    if (!this.validateValueByType(value, this.type)) {
      this.valueItemForm.controls.value.setErrors({wrongType: true});
    }
  }

  private validateValueByType(value: string, type: string) {
    switch (type) {
      case DATA_TYPE.BOOLEAN:
      case DATA_TYPE.BOOL: {
        return this.isBoolean(value);
      }
      case DATA_TYPE.FLOAT:
      case DATA_TYPE.FLOAT64: {
        return this.isFloat(value);
      }
      case DATA_TYPE.INTEGER:
      case DATA_TYPE.INT32:
      case DATA_TYPE.INT64:
      case DATA_TYPE.UINT16:
      case DATA_TYPE.UINT32:
      case DATA_TYPE.INT16:
      case DATA_TYPE.TIMESTAMP: {
        return this.isInteger(value);
      }
      default: {
        return true;
      }
    }
  }

  private isBoolean(value: string): boolean {
    if (!value || value.length === 0 || value.trim().length === 0) {
      return false;
    }
    return value.toLowerCase() === 'true' || value.toLowerCase() === 'false';
  }

  private isFloat(value: string): boolean {
    if (!value || value.length === 0 || value.trim().length === 0) {
      return false;
    }
    return this.utilsService.isNumeric(Number(value));
  }

  private isInteger(value: string): boolean {
    if (!value || value.length === 0 || value.trim().length === 0) {
      return false;
    }

    if (!this.utilsService.isNumeric(Number(value))) {
      return false;
    }
    return Number.isInteger(parseFloat(value));
  }

  onStartDateChange() {
    this.resetDateErrors();

    const startTimestamp: string = this.valueItemForm.controls.startTimestamp.value;
    const endTimestamp: string = this.valueItemForm.controls.endTimestamp.value;

    if (startTimestamp > endTimestamp) {
      this.valueItemForm.controls.startTimestamp.setErrors({wrong: true});
    } else {
      this.dateChangedEvent.emit(startTimestamp);
    }
  }

  onEndDateChange() {
    this.resetDateErrors();

    const startTimestamp: string = this.valueItemForm.controls.startTimestamp.value;
    const endTimestamp: string = this.valueItemForm.controls.endTimestamp.value;

    if (startTimestamp > endTimestamp) {
      this.valueItemForm.controls.endTimestamp.setErrors({wrong: true});
    } else {
      this.dateChangedEvent.emit(endTimestamp);
    }
  }

  private resetDateErrors() {
    this.valueItemForm.controls.startTimestamp.setErrors(null);
    this.valueItemForm.controls.endTimestamp.setErrors(null);
  }
}
